import React from 'react';
import Input from '../../../components/ui/Input';

const SearchSection = ({ searchFilters, onSearchChange }) => {
  return (
    <div className="mb-6">
      <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl shadow-lg p-6">
        <h3 className="text-lg font-medium text-white mb-4">Search & Filter</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-blue-100 mb-2">
              Song Title
            </label>
            <Input
              type="text"
              placeholder="Search by song title..."
              value={searchFilters?.songTitle || ''}
              onChange={(e) => onSearchChange('songTitle', e?.target?.value)}
              className="rounded-lg bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-300"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-blue-100 mb-2">
              Musical
            </label>
            <Input
              type="text"
              placeholder="Search by musical..."
              value={searchFilters?.musical || ''}
              onChange={(e) => onSearchChange('musical', e?.target?.value)}
              className="rounded-lg bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-300"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-blue-100 mb-2">
              Editor
            </label>
            <Input
              type="text"
              placeholder="Search by editor..."
              value={searchFilters?.editor || ''}
              onChange={(e) => onSearchChange('editor', e?.target?.value)}
              className="rounded-lg bg-white bg-opacity-10 border-white border-opacity-30 text-white placeholder-blue-300"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchSection;